<template>
	<div class="popToast-container">
		<div class="centerContent">
			<img class="sucIcon" :src="imgPtahUrl" />
			<div class="title" v-if="desc">
				{{desc}}
			</div>
			<div class="titleTwo" v-if="descTwo">
				{{descTwo}}
			</div>
			<div class="subTitle" v-if="subTitle">
				{{subTitle}}
			</div>
			<div class="ok" @click="clickOk">
				{{btnTitle}}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'PopToast',
		props: {
			// 路径
			imgPtahUrl: {
				type: String,
				default: ''
			},
			// 描述
			desc: {
				type: String,
				default: ''
			},
			descTwo: {
				type: String,
				default: ''
			},
			subTitle: {
				type: String,
				default: ''
			},
			btnTitle: {
				type: String,
				default: '好的'
			},
		},
		data() {
			return {}
		},
		methods: {
			clickOk() {
				this.$emit('clickOk', {})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.popToast-container {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.5);
		z-index: 9999;
	}

	@media (max-width: 480px) {
		.centerContent {
			display: flex;
			flex-direction: column;
			width: 6.2rem;
			background: #FFFFFF;
			border-radius: .24rem;
			padding: 0 .36rem;
			background: #1F2027;
			box-shadow: 0px 2px 23px 0px rgba(16, 97, 198, .2);
			border: .01rem solid rgba(151, 151, 151, .2);

			.sucIcon {
				width: 1.28rem;
				height: 1.28rem;
				margin: .8rem auto 0;
			}

			.title {
				margin: .48rem 0 0;
				font-weight: 500;
				font-size: .32rem;
				color: rgba(255, 255, 255, .8);
				text-align: center;
			}

			.titleTwo {
				margin: 0 auto;
				font-weight: 500;
				font-size: .32rem;
				color: rgba(255, 255, 255, .8);
				text-align: center;
			}

			.subTitle {
				margin: .16rem auto 0;
				max-width: 4rem;
				font-weight: 400;
				font-size: .28rem;
				color: rgba(255, 255, 255, .8);
				text-align: center;
			}

			.ok {
				margin: .48rem auto .64rem;
				width: 3.52rem;
				height: .72rem;
				background: #1673E6;
				border-radius: .36rem;
				font-weight: 400;
				font-size: .28rem;
				color: #FFFFFF;
				text-align: center;
				line-height: .72rem;
				cursor: pointer;
			}
		}
	}

	@media (min-width: 481px) {
		.centerContent {
			display: flex;
			flex-direction: column;
			width: 3.1rem;
			background: #FFFFFF;
			border-radius: .12rem;
			padding: 0 .24rem;
			background: #1F2027;
			box-shadow: 0px 2px 23px 0px rgba(16, 97, 198, .2);
			border: .01rem solid rgba(151, 151, 151, .2);

			.sucIcon {
				width: .64rem;
				height: .64rem;
				margin: .4rem auto 0;
			}

			.title {
				margin: .24rem 0 0;
				font-weight: 500;
				font-size: .16rem;
				color: rgba(255, 255, 255, .8);
				text-align: center;
			}

			.titleTwo {
				margin: 0 auto;
				font-weight: 500;
				font-size: .16rem;
				color: rgba(255, 255, 255, .8);
				text-align: center;
			}

			.subTitle {
				margin: .08rem auto 0;
				max-width: 2rem;
				font-weight: 400;
				font-size: .14rem;
				color: rgba(255, 255, 255, .8);
				text-align: center;
			}

			.ok {
				margin: .24rem auto .32rem;
				width: 1.76rem;
				height: .36rem;
				background: #1673E6;
				border-radius: .18rem;
				font-weight: 400;
				font-size: .14rem;
				color: #FFFFFF;
				text-align: center;
				line-height: .36rem;
				cursor: pointer;
			}
		}
	}
</style>